import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { RadioType } from '../../../shared/enums/radio-type.enums';

@Component({
  selector: 'hdi-radio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class RadioComponent {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() radioType: RadioType = RadioType.CIRCLE;
  @Input() label?: string;
  @Input() value: string = '';
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() multiSelectable: boolean = false;
  @Output() changes: EventEmitter<string> = new EventEmitter<string>();

  RadioType = RadioType;

  onChange(event: Event) {
    if (!this.disabled) {
      const isChecked = (event.target as HTMLInputElement).checked;
      if (this.multiSelectable) {
        this.checked = isChecked;
      } else {
        this.checked = !this.checked;
      }
      this.changes.emit(this.value);
    }
  }
}
